import React from 'react';
import { Link } from 'react-router-dom';
import './FooterV2.css';
import SocialLinks from '../SocialLinks';
import servicesAndPricing from '../../data/servicesAndPricing';

const QUICK_LINKS = [
  { to: '/about', label: 'About Us' },
  { to: '/services', label: 'Services' },
  { to: '/prices', label: 'Prices' },
  { to: '/faqs', label: 'FAQs' },
  { to: '/new-clients', label: 'New Clients' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/accessibility-statement', label: 'Accessibility Statement' },
];

const FooterV2 = () => {
  return (
    <footer className="footer-v2">
      <div className="footer-v2-main">
        <div className="footer-v2-grid">
          <div className="footer-v2-brand">
            {/* Branded wordmark — rendered as a styled <p>, not a heading, so it
                doesn't break heading order on pages that only have an h1 above. */}
            <p className="footer-v2-logo-text">The Dog Lodge</p>
            <p className="footer-v2-tagline">Daycare &amp; Boarding</p>
            <p className="footer-v2-description">
              A cozy, homestyle retreat for a select group of well-behaved pups in San Diego.
            </p>
            <div className="footer-v2-social">
              <SocialLinks />
            </div>
          </div>

          <div className="footer-v2-column">
            <h2 className="footer-v2-heading">Quick Links</h2>
            <nav className="footer-v2-links" aria-label="Footer quick links">
              <ul>
                {QUICK_LINKS.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} onClick={() => window.scrollTo(0, 0)}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="footer-v2-column">
            <h2 className="footer-v2-heading">Contact</h2>
            <div className="footer-v2-contact-list">
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(servicesAndPricing.address)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-v2-contact-item"
                aria-label={`Address: ${servicesAndPricing.address} — opens in Google Maps in a new tab`}
              >
                <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                <span>{servicesAndPricing.address}</span>
              </a>
              <a
                href={`mailto:${servicesAndPricing.email}`}
                className="footer-v2-contact-item"
                aria-label={`Email us at ${servicesAndPricing.email}`}
              >
                <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                <span>{servicesAndPricing.email}</span>
              </a>
              <a
                href={`tel:${servicesAndPricing.phone1}`}
                className="footer-v2-contact-item"
                aria-label={`Call us at ${servicesAndPricing.phone1}`}
              >
                <i className="fa-solid fa-phone" aria-hidden="true"></i>
                <span>{servicesAndPricing.phone1}</span>
              </a>
            </div>
          </div>

          <div className="footer-v2-column">
            <h2 className="footer-v2-heading">Hours</h2>
            <div className="footer-v2-hours">
              <div className="footer-v2-hours-row">
                <span>Monday - Sunday</span>
                <span>8:00am - 8:00pm</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-v2-bottom">
        <p>&copy; {new Date().getFullYear()} The Dog Lodge. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterV2;
